module.exports = __webpack_public_path__ + "static/media/bloodThinner.10d6569b.mp3";